import { useTranslation } from 'react-i18next'

import { ProfileCreatedWidget } from '../../Widget'
import { useNewsboardPostProfileContext } from '../Newsboard.hooks'

import { getWidgetUser } from './NewsboardPostProfileWidgetCreated.utils'

function NewsboardPostProfileWidgetCreated() {
  const { t } = useTranslation()

  const { isInitiated, postData } = useNewsboardPostProfileContext()

  return (
    <ProfileCreatedWidget
      contentProps={{
        createdAt: postData?.created,
        createdBy: getWidgetUser(postData?.owner_obj),
        updatedAt: postData?.updated,
        updatedBy: getWidgetUser(postData?.updated_by_obj),
      }}
      isSkeleton={!isInitiated}
      title={t('Widget.CreatedTitleKey')}
    />
  )
}

export default NewsboardPostProfileWidgetCreated
